export default (() => {

    function trim(obj) {

        if ((!Array.isArray(obj) && typeof obj !== 'object') || obj !== null) {

            return obj;
        }

        return Object.keys(obj).reduce((acc, key) => {

            if (typeof obj[key] === 'object' || Array.isArray(obj[key])) {
                acc[key.trim()] = trim(obj[key]);
            } else if (typeof obj[key] === 'string') {
                acc[key.trim()] = obj[key].trim();
            }

            return acc;

        }, Array.isArray(obj) ? [] : {});
    }

    return {
        trim
    };

})();


// WEBPACK FOOTER //
// ./services/trimmer.js